'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DrawerHeaderNavigation", {
    enumerable: true,
    get: function() {
        return DrawerHeaderNavigation;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useDrawerHeaderNavigation = require("./useDrawerHeaderNavigation");
const _renderDrawerHeaderNavigation = require("./renderDrawerHeaderNavigation");
const _useDrawerHeaderNavigationStylesstyles = require("./useDrawerHeaderNavigationStyles.styles");
const DrawerHeaderNavigation = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useDrawerHeaderNavigation.useDrawerHeaderNavigation_unstable)(props, ref);
    (0, _useDrawerHeaderNavigationStylesstyles.useDrawerHeaderNavigationStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDrawerHeaderNavigationStyles_unstable')(state);
    return (0, _renderDrawerHeaderNavigation.renderDrawerHeaderNavigation_unstable)(state);
});
DrawerHeaderNavigation.displayName = 'DrawerHeaderNavigation';
